import gql from "graphql-tag";

export default gql`
  mutation restartSource($sourceId: ID) {
    restartSource(sourceId: $sourceId) {
      id
    }
  }
`;
